import { render, staticRenderFns } from "./InstalacoesVisitaCard.vue?vue&type=template&id=bfd76262&"
import script from "./InstalacoesVisitaCard.vue?vue&type=script&lang=js&"
export * from "./InstalacoesVisitaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports